import styled, { css, keyframes } from 'styled-components'

import { radius, RadiusKeys, spacing } from '../../../themes'

interface ContainerProps {
  rounded?: RadiusKeys
  width?: number
  height?: number
}

const gradient = keyframes`
  0% {
    background-position: 100% 145%;
  }
  50% {
    background-position: 0% 45%;
  }
  100% {
    background-position: -10% 0%;
  }
`

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !['height', 'width'].includes(prop),
})<ContainerProps>`
  ${({ rounded }) =>
    rounded &&
    css`
      border-radius: ${radius(rounded)};
    `}
  padding: ${spacing(2)};
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(190, 190, 190, 0.2);
  background: linear-gradient(
    90deg,
    rgba(190, 190, 190, 0.2),
    rgba(129, 129, 129, 0.24) 37%,
    rgba(190, 190, 190, 0.2) 63%
  );
  background-size: 400% 400%;
  animation: ${gradient} 1.4s ease infinite;
  height: ${({ height }) => height ?? 100}px;
  width: ${({ width }) => width ?? 100}px;
`
